<template>
  <div class="runningTimeHistory">
    <el-date-picker
      v-model="historyTime"
      type="date"
      placeholder="选择日期"
      size="small"
      :clearable="false"
      format="yyyy-MM-dd"
      :picker-options="pickerOptions"
    >
    </el-date-picker>
    <el-button
      type="primary"
      plain
      size="small"
      style="margin-left: 20px"
      @click="
        getTagList();
        getRunTimeCharts();
      "
      :loading="loading"
      >查询</el-button
    >
    <div class="timeList">
      <template v-if="tags.length">
        <el-tag
          v-for="(v, i) in tags"
          :key="i"
          :closable="false"
          style="margin: 10px 2px 2px 10px"
        >
          {{ v.name }}
        </el-tag>
      </template>
      <template v-else>
        <p>未设置运行时间</p>
      </template>
    </div>
    <div class="historyCharts" style="height: 50vh; margin: 20px 0">
      <RunningTimeCharts :id="'charts'" :chartsData="chartsData" />
    </div>
  </div>
</template>

<script>
import RunningTimeCharts from "@/components/shebeiguanli/RunningTimeCharts.vue";
import { dateFtt } from "@/assets/js/utils";
import api from "@/api";
export default {
  props: ["activeItem"],
  components: {
    RunningTimeCharts,
  },
  data() {
    return {
      historyTime: new Date().getTime() - 3600 * 1000 * 24,
      chartsData: {},
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now() - 8.64e7;
        },
      },
      tags: [],
      loading: false,
    };
  },
  methods: {
    async getTagList() {
      this.tags = [];
      let res = await api.getSetRuntimeList({
        deviceId: this.activeItem.deviceId
          ? this.activeItem.deviceId
          : this.activeItem.id.id,
        date: dateFtt("yyyy-MM-dd", new Date(this.historyTime)),
      });
      if (res && res.data.code == 200) {
        res.data.data.forEach((v) => {
          let str = "";
          if (v.type == 0) {
            str = `${v.beginTs}-${v.endTs} 单次 ${v.settingDate}`;
          } else {
            let arr = v.range.split(";");
            str = `${v.beginTs}-${v.endTs} 重复 ${
              arr.length == 7 ? "每天" : arr.join("、")
            }`;
          }
          str += v.status == 1 ? "(已删除)" : v.status == 5 ? "(部分生效)" : "";
          this.tags.push({ name: str, status: v.status, id: v.id });
        });
      }
    },
    async getRunTimeCharts() {
      this.loading = true;
      this.chartsData = {
        xData: [],
        data: [],
      };
      let res = await api.getSetRuntimeCharts({
        deviceId: this.activeItem.deviceId
          ? this.activeItem.deviceId
          : this.activeItem.id.id,
        entityType: "DEVICE",
        interval: 3600,
        projectId: JSON.parse(window.sessionStorage.getItem("userInfo")).projects[0].projectId,
        key: "RunSign",
        date: dateFtt("yyyy-MM-dd", new Date(this.historyTime)),
      });
      if (res && res.data.code == 200) {
        this.loading = false;
        res.data.data.forEach((v) => {
          this.chartsData.xData.push(dateFtt("hh:mm", new Date(v.time)));
          let item = null;
          switch (v.status) {
            case 0:
              item = v.runTime;
              break;
            case 1:
              item = {
                value: v.runTime,
                itemStyle: {
                  color: {
                    x: 0,
                    y: 0,
                    x2: 0,
                    y2: 1,
                    colorStops: [
                      {
                        offset: 0,
                        color: "rgba(254, 174, 162, 1)",
                      },
                      {
                        offset: 0.7,
                        color: "rgba(253, 114, 112, 1)",
                      },
                    ],
                    globalCoord: false,
                  },
                },
              };
              break;
            case 2:
              item = {
                value: v.runTime,
                itemStyle: {
                  color: {
                    x: 0,
                    y: 0,
                    x2: 0,
                    y2: 1,
                    colorStops: [
                      {
                        offset: 0,
                        color: "rgba(135,163,210,.2)",
                      },
                      {
                        offset: 1,
                        color: "rgba(135,163,210,.4)",
                      },
                    ],
                    globalCoord: false,
                  },
                },
              };
              break;
          }
          this.chartsData.data.push(item);
        });
      }
    },
  },

  created() {
    this.getTagList();
    this.getRunTimeCharts();
  },
};
</script>

<style lang="scss" scoped>
.runningTimeHistory {
  width: 100%;
  height: 100%;
  .timeList {
    width: 95%;
    height: 80px;
    background: #f3f7ff;
    border-radius: 10px;
    margin-top: 20px;
    overflow: auto;
    p {
      text-align: center;
      line-height: 70px;
      color: #999;
    }
  }
}
</style>